export const iconFontAwesomeReligionCross = (
	<i className="fa-solid fa-cross"></i>
);
